import ajax from '@/utils/ajax';

export default {
    load: id => ajax.get(`/api/delegations/${id}`),
    riverCursors: id => ajax.get(`/api/delegations/${id}/riverCursors`),
    loadWithRiverCursors: id => ajax.get(`/api/delegations/${id}/withRiverCursors`),
};
